<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="activityId" >
        <span slot="label" ><a-tooltip>{{ $t('活动ID，外键{community_group_activity.id}') }}<template slot="title">{{ $t('活动ID，外键{community_group_activity.id}') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.activityId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'活动ID，外键{community_group_activity.id}'" />
      </a-form-model-item>
      <a-form-model-item prop="groupId" >
        <span slot="label" ><a-tooltip>{{ $t('小组ID，外键{community_group.id}') }}<template slot="title">{{ $t('小组ID，外键{community_group.id}') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.groupId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'小组ID，外键{community_group.id}'" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" ><a-tooltip>{{ $t('备注') }}<template slot="title">{{ $t('备注') }}</template></a-tooltip> </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getCommunityGroupActivityRelation, addCommunityGroupActivityRelation, updateCommunityGroupActivityRelation } from '@/api/community/communityGroup/communityGroupActivityRelation'
  import { mapGetters } from 'vuex'
  import CustomDictTag from '@/components/DictCustomTag'
  import { generateFilePath, uploadObject } from '@/api/tool/oss'
  import LocaleFieldButton from '@/components/locale/LocaleFieldButton.vue'
  import moment from 'moment'

  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        activityId: null,
        groupId: null,
        remark: null,
        localeFieldMap: {}
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
          activityId: [{ required: true, message: this.$t('活动ID，外键{community_group_activity.id}') + this.$t('不能为空'), trigger: 'blur' }],
          groupId: [{ required: true, message: this.$t('小组ID，外键{community_group.id}') + this.$t('不能为空'), trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    moment,
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        activityId: null,
        groupId: null,
        remark: null,
        localeFieldMap: {}
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCommunityGroupActivityRelation({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCommunityGroupActivityRelation(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addCommunityGroupActivityRelation(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
